/* eslint-disable */
export default {
  noActiveCalls: 'アクティブな通話はありません',
  noRecords: '結果が見つかりません。',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
